export const routes = {
    dashboard: {
      base: {
        main: 'dashboard',
      },
      labels: {
        main: 'Dashboard KPI',
      },
      paths: {
        main: 'dashboard',
      }
    },
    logbook: {
      base: {
        main: 'logbook',
      },
      labels: {
        main: 'Bitácora',
      },
      paths: {
        main: 'dashboard/logbook',
      }
    },
    filesManager: {
      base: {
        main: 'filesManager/',
      },
      labels: {
        main: 'Repositorio de archivos',
      },
      paths: {
        main: 'dashboard/filesManager/main',
      }
    },
    reports: {
      base: {
        main: 'reports',
        programmed: 'programmed',
        programation: 'programation',
        'progress-questionnaire': 'progress-questionnaire',
      },
      labels: {
        main: 'Reportes por',
        programmed: 'Programaciones',
        programation: 'Áreas y departamentos',
        'progress-questionnaire': 'Avance de cuestionarios',
      },
      paths: {
        programmed: 'dashboard/reports/programmed',
        programation: 'dashboard/reports/programation',
        'progress-questionnaire': 'dashboard/reports/progress-questionnaire',
      }
    },
    'organization-chart': {
      base: {
        main: 'organization-chart',
        area: 'area',
        departments: 'departments',
        'area-department': 'organization-area-department',
      },
      labels: {
        main: 'Organigrama',
        area: 'Área',
        departments: 'Departamento',
        'area-department': 'Asociación de catálogos',
      },
      paths: {
        area: 'dashboard/organization-chart/area',
        departments: 'dashboard/organization-chart/departments',
        'area-department': 'dashboard/organization-chart/organization-area-department',
      }
    },
    service: {
      base: {
        main: 'service',
        'area-department': 'area-department',
        'time-config': 'time-config',
      },
      labels: {
        main: 'Configuración general',
        'area-department': 'Áreas y departamentos',
        'time-config': 'Niveles de servicios',
      },
      paths: {
        'area-department': 'dashboard/service/area-department',
        'time-config': 'dashboard/report-folio/time-config',
      },
    },
    user: {
      base: {
        main: 'user',
        register: 'register',
        'user-type': 'user-type',
        'group-gestion':'group-gestion'
      },
      labels: {
        main: 'Usuario',
        register: 'Registro de usuarios',
        'user-type': 'Tipo de usuario',
        'group-gestion': 'Gestion de grupos',
      },
      paths: {
        register: 'dashboard/user/register',
        'user-type': 'dashboard/user/user-type',
        'group-gestion':'dashboard/user/group-gestion'
      }
    },
    unit: {
      base: {
        main: 'unit',
        store: 'store',
        division: 'division',
        zone: 'zone',
      },
      labels: {
        main: 'Unidad',
        store: 'Registro de unidad',
        division: 'Divisiones',
        zone: 'Zonas',
      },
      paths: {
        store: 'dashboard/unit/store',
        division: 'dashboard/unit/division',
        zone: 'dashboard/unit/zone',
      }
    },
    questionnarie: {
      base: {
        main: 'questionnarie',
      },
      labels: {
        main: 'Cuestionario',
      },
      paths: {
        main: 'dashboard/questionnarie/main',
      }
    },
    calendar: {
      base: {
        main: 'calendar',
      },
      labels: {
        main: 'Agenda por unidad',
      },
      paths: {
        main: 'dashboard/calendar',
      }
    },
    'schedule-user': {
      base: {
        main: 'schedule-user',
      },
      labels: {
        main: 'Agenda de usuarios',
      },
      paths: {
        main: 'dashboard/schedule-user/',
      }
    },
    'action-plan': {
      base: {
        main: 'action-plan',
      },
      labels: {
        main: 'Planes de acción',
      },
      paths: {
        main: 'dashboard/action-plan',
      }
    },
    'report-folio': {
      base: {
        main: 'report-folio',
        dashboard: 'dashboard',
        settings: 'settings',
        'catalog' : 'catalog'
      },
      labels: {
        main: 'Folios',
        dashboard: 'Dashboard',
        settings: 'Configuración general',
        'catalog' : 'Configuración de catálogos'
      },
      paths: {
        dashboard: 'dashboard/report-folio/dashboard',
        settings: 'dashboard/report-folio/settings',
        'catalog' : 'dashboard/report-folio/catalog'
      }
    },
    setting: {
      base: {
        main: 'setting',
        'admin-users': 'admin-users',
        'option-group': 'option-group',
        companies: 'companies',
        dropList: 'dropList',
      },
      labels: {
        main: 'Configuración',
        'admin-users': 'Administradores',
        'option-group': 'Grupo de opciones',
        companies: 'Compañías',
        dropList: 'Listas desplegables',
      },
      paths: {
        'admin-users': 'dashboard/setting/admin-users',
        'option-group': 'dashboard/setting/option-group',
        companies: 'dashboard/setting/companies',
        dropList: 'dashboard/setting/dropList',
      }
    },
    localization: {
      base: {
        main: 'localization',
      },
      labels: {
        main: 'Localización',
      },
      paths: {
        main: 'dashboard/localization/main',
      }
    }
  }
  